import { jsx, jsxs } from 'react/jsx-runtime';
import { InfoBox } from '../InfoBox.js';

function NoResultsMessage(_ref) {
  let {
    message = 'Found no results.',
    hint = 'Try broadening your search or adjusting your filters.',
    className
  } = _ref;
  return jsx("div", {
    className: className || 'flex align-items-center justify-content-center flex-1 py-4',
    children: jsx(InfoBox, {
      iconSize: "normal",
      children: jsxs("div", {
        className: "flex flex-column gap-1",
        children: [jsx("span", {
          className: "font-semibold",
          children: message
        }), hint && jsx("span", {
          className: "text-sm text-color-secondary",
          children: hint
        })]
      })
    })
  });
}

export { NoResultsMessage };
